// Mounts you can earn, and the airship. Every mount is a breed of woolly cloud-sheep: the Woolcloud you start
// with, and three more traded for at the stable (Town Gate) with what you bring back from the wilds.
// The airship is bought at the Sky Dock, and the party can chip in together.
type ItemStack = { def: string; qty: number };

export interface MountDef {
  id: string; kind: number; name: string; blurb: string; perk: string;
  seats: 1 | 2;          // 2: a party member can ride behind you
  speed: number;         // on the ground, percent of normal
  fly: number;           // in the air, percent of normal (0: can't fly)
  sneak: boolean;        // creatures don't notice you while you ride
  wool: [string, string, string]; face: string;   // colours: wool light, mid, shade; face
  scale: number;         // the Big Bramble is bigger
  cost: { gold: number; items: ItemStack[] } | null;   // null: everyone has it
}

export const MOUNTS: MountDef[] = [
  { id: 'woolcloud', kind: 1, name: 'Woolcloud', blurb: 'Your first friend: a round little sheep that floats like a cloud.', perk: 'Rides and flies.',
    seats: 1, speed: 100, fly: 100, sneak: false, wool: ['#fbf7ee', '#efe6d6', '#ddd0bb'], face: '#5a4a44', scale: 1, cost: null },
  { id: 'mossback', kind: 2, name: 'Mossback', blurb: 'A green-wooled sheep from the edge of Whisperwood. Quick, and very quiet.', perk: 'Faster on the ground, and creatures don\'t notice you while you ride.',
    seats: 1, speed: 120, fly: 100, sneak: true, wool: ['#b8d49a', '#9cbf7e', '#7ea263'], face: '#3e4a34', scale: 1,
    cost: { gold: 120, items: [{ def: 'wolf_pelt', qty: 5 }] } },
  { id: 'bramble', kind: 3, name: 'Big Bramble', blurb: 'A huge, gentle sheep, crowned like the Briar Drake. Room for two.', perk: 'Two seats: a party member can ride behind you.',
    seats: 2, speed: 95, fly: 90, sneak: false, wool: ['#e9c9a8', '#d6b08c', '#bb9068'], face: '#5a3a2a', scale: 1.3,
    cost: { gold: 150, items: [{ def: 'boar_tusk', qty: 4 }, { def: 'bramble_crown', qty: 1 }] } },
  { id: 'gloamwool', kind: 4, name: 'Gloamwool', blurb: 'Lavender wool that glows faintly, spun from Gloomhollow veil-light.', perk: 'The fastest flier, and it glows in the dark.',
    seats: 1, speed: 100, fly: 135, sneak: false, wool: ['#e4d8f6', '#cbb8ea', '#a690d4'], face: '#3a3058', scale: 1,
    cost: { gold: 250, items: [{ def: 'wisp_ember', qty: 4 }, { def: 'bone_dust', qty: 6 }] } },
];

/** The airship's mount kind (it moves by the same rules, high above everything). */
export const AIRSHIP = 9;
/** What an airship costs. Anyone in the party can chip in toward the leader's ship. */
export const AIRSHIP_COST = 1000;
/** How many can come along on an airship: the captain's whole party. */
export const AIRSHIP_SEATS = 8;
/** Where the Sky Dock is on the overworld (tile); you board your airship there. */
export const DOCK_TILE: [number, number] = [65, 33];

export const mountById = (id: string): MountDef | undefined => MOUNTS.find(m => m.id === id);
export const mountByKind = (k: number): MountDef => MOUNTS.find(m => m.kind === k) ?? MOUNTS[0];
/** How many people can ride behind the rider. */
export const seatsOf = (kind: number): number => kind === AIRSHIP ? AIRSHIP_SEATS - 1 : mountByKind(kind).seats - 1;
